import { render } from "./NotFound.vue?vue&type=template&id=671089ba"
const script = {}

import exportComponent from "C:\\wamp64\\www\\MXRover\\mxrover_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__